import { StorageService } from '@/shared/utils/storage-service'
import { Injector } from '@/config/dependency-injection'
import { DevelopmentSettings } from '@/shared/development/models/development-settings'

export class DevelopmentService {
  private storageService: StorageService = Injector.get(StorageService)

  private STORAGE_KEY = 'development-settings'

  /**
   * Returns the current development settings.
   * If none are defined then a default settings object will be created
   */
  public getSettings(): DevelopmentSettings {
    return (
      this.storageService.getItem<DevelopmentSettings>(this.STORAGE_KEY) || {
        delay: {
          active: false,
          max: 0,
          min: 0,
        },

        killUrls: [],
      }
    )
  }

  /**
   * Store the development settings
   * @param settings
   */
  public updateSettings(settings: DevelopmentSettings): void {
    this.storageService.setItem(this.STORAGE_KEY, settings)
  }
}
